import * as React from 'react';
import { styles } from './styles';
import { Transition } from 'react-transition-group';
import { TransitionProps, ExitHandler } from 'react-transition-group/Transition';
import { animations } from '@joykit/transitions/Fade/animations';
import { cx } from 'emotion';

interface Props extends Pick<TransitionProps, 'unmountOnExit'> {
  in: boolean;
  className?: string;
  timeout?: TransitionProps['timeout'];
  onExited?: ExitHandler;
  animateOnMount?: boolean;
  property?: Property;
}

type Property = 'opacity' | 'background-color';

const Fade: React.SFC<Props> = ({
  in: inProp,
  children,
  unmountOnExit,
  className,
  animateOnMount = true,
  timeout = 0,
  onExited,
  property = 'opacity'
}) => {
  return (
    <Transition in={inProp} appear={animateOnMount} unmountOnExit={unmountOnExit} timeout={timeout} onExited={onExited}>
      {state => {
        return (
          <div className={cx(styles.container, className)} style={animations.states[state]}>
            {children}
          </div>
        );
      }}
    </Transition>
  );
};

export { Fade };
